import React from 'react';
import Router from './router';
import {Provider} from 'react-redux';
import {store} from './store'

import 'react-confirm-alert/src/react-confirm-alert.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './static/css/bootstrap-utilities.min.css';
import './static/css/bootstrap-multiselect.css'
import './static/css/styles.css';
import './static/css/adaptive.css';
import './static/css/custom.css';
import './static/css/circle.css';
import './static/css/fonts.css';
import './static/css/swiper.css';
import './static/css/react-select.css';
import './components/ui/LoadingDots/index.css';
import './static/css/app.css';
import './static/css/content.css'

class App extends React.Component {
  render = () => (
    <Provider store={store}>
      <Router />
    </Provider>
  )
}

export default App;
